
import { required, sameAs, requiredIf } from 'vuelidate/lib/validators'

const isValidEmail = (value) => {
    // eslint-disable-next-line no-control-regex
    const emailRegExp = /(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[A-Za-z0-9-]*[A-Za-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
    return !!emailRegExp.test(value)
}

export default {
    validations: {
        user: {
            email: {
                required,
                isValidEmail
            },
            currentPassword: {
                required: requiredIf(function () {
                    return this.changePassword
                }),
            },
            newPassword: {
                required: requiredIf(function () {
                    return this.changePassword
                }),
            },
            confirmPassword: {
                required: requiredIf(function () {
                    return this.changePassword
                }),
                sameAsPassword: sameAs('newPassword')
            }
        }
    },

    computed: {
        emailErrors () {
            let errors = ''

            if (!this.$v.user.email.$dirty) {
                return errors
            }

            if (!this.$v.user.email.required) errors = errors.concat(this.$t('validations.email_is_required'))

            if (!this.$v.user.email.isValidEmail) errors = errors.concat(this.$t('validations.email_has_invalid_format'))

            return errors
        },

        passwordErrors () {
            let errors = ''

            if (!this.$v.user.currentPassword.$dirty) {
                return errors
            }

            if (!this.$v.user.currentPassword.required) errors = errors.concat(this.$t('validations.password_is_required'))

            return errors
        },

        newPasswordErrors () {
            let errors = ''

            if (!this.$v.user.newPassword.$dirty) {
                return errors
            }

            if (!this.$v.user.newPassword.required) errors = errors.concat(this.$t('validations.password_is_required'))

            return errors
        },

        passwordConfirmErrors () {
            let errors = ''

            if (!this.$v.user.confirmPassword.$dirty) {
                return errors
            }

            if (!this.$v.user.confirmPassword.required) errors = errors.concat(this.$t('validations.password_confirm_is_required'))

            if (!this.$v.user.confirmPassword.sameAsPassword) errors = errors.concat(this.$t('validations.password_confirm_do_not_match_password'))

            return errors
        }
    }
}